import { render, staticRenderFns } from "./textDataField.vue?vue&type=template&id=0a47089c&scoped=true"
import script from "./textDataField.vue?vue&type=script&lang=js"
export * from "./textDataField.vue?vue&type=script&lang=js"
import style0 from "./textDataField.vue?vue&type=style&index=0&id=0a47089c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a47089c",
  null
  
)

export default component.exports